import find from 'lodash/find';
import { ObjectModel } from '@types';

export const findParentModel = (models: Record<string, ObjectModel>, modelId: ObjectModel['id']) =>
    find(models, model => model.id === modelId || model.child_models.includes(modelId));
